import { convertThemeToCSS, ThemeLightValues, Theme } from '@picsart/cascade/colors';

const colors = Theme;

const getColor = (key: string): string =>
  getComputedStyle(document.documentElement).getPropertyValue(key);

const changeThemeColors = () => {
  const styleTag = document.createElement('style');
  styleTag.innerText = `
    :root {
      ${Object.entries(convertThemeToCSS(ThemeLightValues)).reduce(
        (acc, [color, value]) => `${acc}${color}: ${value};\n`,
        ''
      )}
    }
  `;
  return styleTag;
};

export { colors, changeThemeColors, getColor };
